
const countries = [
  { code: 'TW', name: '台灣', name_en: 'Taiwan', name_zh: '台灣' },
  { code: 'CN', name: '中國', name_en: 'China', name_zh: '中國' },
  { code: 'HK', name: '香港', name_en: 'Hong Kong', name_zh: '香港' },
  { code: 'MO', name: '澳門', name_en: 'Macau', name_zh: '澳門' },
  { code: 'JP', name: '日本', name_en: 'Japan', name_zh: '日本' },
  { code: 'KR', name: '韓國', name_en: 'South Korea', name_zh: '韓國' },
  { code: 'SG', name: '新加坡', name_en: 'Singapore', name_zh: '新加坡' },
  { code: 'MY', name: '馬來西亞', name_en: 'Malaysia', name_zh: '馬來西亞' },
  { code: 'US', name: '美國', name_en: 'United States', name_zh: '美國' },
  { code: 'CA', name: '加拿大', name_en: 'Canada', name_zh: '加拿大' },
  { code: 'GB', name: '英國', name_en: 'United Kingdom', name_zh: '英國' },
  { code: 'FR', name: '法國', name_en: 'France', name_zh: '法國' },
  { code: 'DE', name: '德國', name_en: 'Germany', name_zh: '德國' },
  { code: 'AU', name: '澳洲', name_en: 'Australia', name_zh: '澳洲' },
  { code: 'NZ', name: '紐西蘭', name_en: 'New Zealand', name_zh: '紐西蘭' },
] as const;

export { countries };
export default countries;
